import React from 'react';
import Header from '../component/template/Header';
import List from '../component/displayHalte/listDisplay';
import Footer from '../component/template/Footer';

function ListDisplay() {
  return (
    <div>
      <Header />
      <div className='content'>
        <div className="tinggi-content">
          <List />
        </div>
          <Footer />
      </div>
    </div>
  );
}

export default ListDisplay;